"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5979],{

/***/ 55979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PJ": function() { return /* reexport */ LeftContent; },
  "aV": function() { return /* reexport */ List; },
  "HC": function() { return /* reexport */ TableOfContents_ListItem; },
  "xv": function() { return /* reexport */ TableOfContents_Text; },
  "Dx": function() { return /* reexport */ TableOfContents_Title; },
  "ZP": function() { return /* reexport */ TableOfContents; },
  "e9": function() { return /* reexport */ TableOfContents_useTableOfContents; }
});

// UNUSED EXPORTS: IconWrapper, Number, RightContent

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableOfContents/Text.views.tsx


var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ev3gaw20"
} : 0)("transition:0.3s color;margin:0;display:flex;gap:8px;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableOfContents/Text.tsx


var _excluded = ["children", "tag", "variant", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseText = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "p" : _ref$tag,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pSmall" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, _objectSpread(_objectSpread(_objectSpread({
    tag: tag,
    ref: ref,
    variant: variant
  }, tokens), rest), {}, {
    children: children
  }));
});
var Text_Text = (0,useDesignTokens/* withDesignTokens */.Y)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.boysenberry[200]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[60]
    };
  }
});
/* harmony default export */ var TableOfContents_Text = (Text_Text);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableOfContents/TableOfContents.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var TableOfContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1uqrupp5"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1uqrupp4"
} : 0)( true ? {
  name: "1vrful5",
  styles: "display:flex;transition:0.3s color"
} : 0);
var TableOfContents_Number = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TableOfContents_Text,  true ? {
  target: "e1uqrupp3"
} : 0)( true ? "" : 0);
var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1uqrupp2"
} : 0)( true ? {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column"
} : 0);
var LeftContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1uqrupp1"
} : 0)( true ? "" : 0);
var RightContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1uqrupp0"
} : 0)( true ? "" : 0);
/* harmony default export */ var TableOfContents_TableOfContents = ((/* unused pure expression or super */ null && (TableOfContents)));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableOfContents/ListItem.views.tsx




var ListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1e0wjtz0"
} : 0)("display:flex;justify-content:space-between;align-items:center;cursor:pointer;width:100%;text-align:left;text-decoration:none;", Text, "{color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";}", IconWrapper, ",", TableOfContents_Number, "{color:", function (_ref2) {
  var accessoryColor = _ref2.accessoryColor;
  return accessoryColor;
}, ";}:hover{", Text, ",", IconWrapper, ",", TableOfContents_Number, "{color:", function (_ref3) {
  var hoverColor = _ref3.hoverColor;
  return hoverColor;
}, ";}}", function (_ref4) {
  var borderDirection = _ref4.borderDirection,
      borderColor = _ref4.borderColor;
  return borderDirection === "left" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("padding:8px 0 8px 16px;border-left:1px solid ", borderColor, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref5) {
  var borderDirection = _ref5.borderDirection,
      borderColor = _ref5.borderColor;
  return borderDirection === "bottom" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("padding:12px 0;border-bottom:1px solid ", borderColor, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref6) {
  var active = _ref6.active,
      borderDirection = _ref6.borderDirection,
      activeColor = _ref6.activeColor;
  return active &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(borderDirection === "left" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("border-color:", activeColor, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0), " ", Text, ",", IconWrapper, ",", TableOfContents_Number, "{color:", activeColor, ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableOfContents/ListItem.tsx


var ListItem_excluded = ["borderDirection", "active", "href", "onClick", "children", "tokens"];

function ListItem_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ListItem_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ListItem_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ListItem_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseListItem = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$borderDirection = _ref.borderDirection,
      borderDirection = _ref$borderDirection === void 0 ? "left" : _ref$borderDirection,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      href = _ref.href,
      onClick = _ref.onClick,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ListItem_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, ListItem_objectSpread(ListItem_objectSpread(ListItem_objectSpread({
    active: active,
    href: href,
    onClick: onClick,
    borderDirection: borderDirection,
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var ListItem_ListItem = (0,useDesignTokens/* withDesignTokens */.Y)(BaseListItem, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500],
      hoverColor: theme.palette.brand.darkAcai[700],
      borderColor: theme.palette.brand.darkAcai[300],
      accessoryColor: theme.palette.brand.darkAcai[400],
      activeColor: theme.palette.brand.boysenberry[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[300],
      hoverColor: theme.palette.brand.darkAcai[200],
      borderColor: theme.palette.brand.darkAcai[500],
      accessoryColor: theme.palette.brand.darkAcai[400],
      activeColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[60],
      hoverColor: theme.palette.twilio.gray[100],
      borderColor: theme.palette.twilio.gray[20],
      accessoryColor: theme.palette.twilio.gray[60],
      activeColor: theme.palette.twilio.blue[60]
    };
  }
});
/* harmony default export */ var TableOfContents_ListItem = (ListItem_ListItem);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableOfContents/Title.views.tsx


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1t7pz0h0"
} : 0)("margin:0 0 16px;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableOfContents/Title.tsx


var Title_excluded = ["variant", "tag", "children", "tokens"];

function Title_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Title_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "buttonLarge" : _ref$variant,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "p" : _ref$tag,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, Title_objectSpread(Title_objectSpread(Title_objectSpread({
    ref: ref,
    variant: variant,
    tag: tag
  }, tokens), rest), {}, {
    children: children
  }));
});
var Title_Title = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[200]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var TableOfContents_Title = (Title_Title);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../libs/utils/useIntersectionObserver/index.ts + 1 modules
var useIntersectionObserver = __webpack_require__(83194);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableOfContents/useTableOfContents.ts




var useTableOfContents = function useTableOfContents(_ref) {
  var ids = _ref.ids,
      options = _ref.options;

  var _useState = (0,react.useState)(),
      elementInView = _useState[0],
      setElementInView = _useState[1];

  (0,useIntersectionObserver/* default */.Z)(ids, function (_ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1),
        entry = _ref3[0];

    if (entry.isIntersecting) {
      setElementInView(entry.target.id);
    }
  }, options);
  return {
    activeElementId: elementInView
  };
};

/* harmony default export */ var TableOfContents_useTableOfContents = (useTableOfContents);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableOfContents/index.ts





TableOfContents.displayName = "TableOfContentsBase";
List.displayName = "TableOfContents.List";
TableOfContents_ListItem.displayName = "TableOfContents.ListItem";
LeftContent.displayName = "TableOfContents.LeftContent";
RightContent.displayName = "TableOfContents.RightContent";
TableOfContents_Title.displayName = "TableOfContents.Title";
IconWrapper.displayName = "TableOfContents.IconWrapper";
TableOfContents_Text.displayName = "TableOfContents.Text";
TableOfContents_Number.displayName = "TableOfContents.Number";


/***/ }),

/***/ 83194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useIntersectionObserver_useIntersectionObserver; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useEventCallback/index.ts
var useEventCallback = __webpack_require__(93026);
;// CONCATENATED MODULE: ../../libs/utils/useIntersectionObserver/useIntersectionObserver.ts



var isRef = function isRef(ref) {
  return typeof ref !== "string";
};

var validSelector = function validSelector(slug) {
  var selector = slug.trim();

  if (selector && selector.match(/^\d/)) {
    selector = selector.replace(/^[0-9]+/, "");
    selector = selector.startsWith("-") ? selector.replace("-", "") : selector;
  }

  return selector;
};
/**
 * A hook to observe elements in the viewport
 * @param refs - An array of refs or selectors
 * @param callback - The function to call when an element is intersecting
 * @param options - The options for the IntersectionObserver
 * @returns An object containing the update function to update the observed elements and the observer reference
 */


var useIntersectionObserver = function useIntersectionObserver(refs, callback, options) {
  var observerRef = (0,react.useRef)();
  var currentlyObserved = (0,react.useRef)(Array.from({
    length: refs.length
  }).fill(null));

  var _useState = (0,react.useState)(0),
      updateCount = _useState[0],
      setUpdateCount = _useState[1];

  var callbackHandle = (0,useEventCallback/* default */.Z)(callback, []);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(callbackHandle, options);
    observerRef.current = intersectionObserver;
    refs.forEach(function (ref, index) {
      var selector = !isRef(ref) && validSelector(ref);
      var element = isRef(ref) ? ref.current : document.querySelector("#".concat(selector));

      if (element && currentlyObserved.current) {
        intersectionObserver.observe(element);
        currentlyObserved.current[index] = element;
      }
    });
    return function () {
      intersectionObserver.disconnect();
      currentlyObserved.current = null;
    };
  }, [updateCount, callbackHandle]);
  var update = (0,react.useCallback)(function () {
    return setUpdateCount(function (state) {
      return ++state;
    });
  }, []); // Update observed element
  // JSX is changing and observed element can be mounted and unmounted from jsx tree
  // This effect takes care of updating currently observed element to newest reference value

  (0,react.useEffect)(function () {
    refs.forEach(function (ref, index) {
      var selector = !isRef(ref) && validSelector(ref);
      var element = isRef(ref) ? ref.current : document.querySelector("#".concat(selector));

      if (observerRef.current && currentlyObserved.current) {
        var areDifferent = currentlyObserved.current[index] !== element;

        if (currentlyObserved.current[index] && areDifferent && isRef(ref)) {
          var _observerRef$current;

          (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 ? void 0 : _observerRef$current.unobserve(currentlyObserved.current[index]);
          currentlyObserved.current[index] = null;
        }

        if (areDifferent && element && isRef(ref)) {
          var _observerRef$current2;

          (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 ? void 0 : _observerRef$current2.observe(element);
          currentlyObserved.current[index] = element;
        }
      }
    });
  });
  return {
    observerRef: observerRef,
    update: update
  };
};

/* harmony default export */ var useIntersectionObserver_useIntersectionObserver = (useIntersectionObserver);
;// CONCATENATED MODULE: ../../libs/utils/useIntersectionObserver/index.ts


/***/ })

}]);